import {useQuery} from "@tanstack/react-query";
import PaymnetStore from "../../../store/paymnet-store";
import { apiClient } from "../../../AxiosConfig";


const fetchPaymentStatus = async () => {
    return apiClient.get(`/v1/payment/tx-status/?tx_id=${PaymnetStore.tx_id}&payment_id=${PaymnetStore.paymentMethod}`)
}


export const usePaymentStatus = (txId) => {
    const {data, isLoading, isSuccess, refetch} = useQuery({
        queryKey: ['tx status'],
        queryFn: () => fetchPaymentStatus(txId),
        select: (data) => data.data,
        refetchInterval: PaymnetStore.paymentMethod === 6 ? 15000 : 5000,
        refetchIntervalInBackground: true,
        enabled: Boolean(txId),
    })

    return {data, isLoading, isSuccess, refetch}
}